import { render } from "./ChessBoard.vue?vue&type=template&id=13a7f104&scoped=true"
import script from "./ChessBoard.vue?vue&type=script&lang=js"
export * from "./ChessBoard.vue?vue&type=script&lang=js"

import "./ChessBoard.vue?vue&type=style&index=0&id=13a7f104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a7f104"]])

export default __exports__